import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { getSimulationLaunch } from '../api';

/**
 * Opens a click simulation: asks the server for a signed address on the
 * simulation host and goes there. The simulation runs on that origin, never
 * on this one (server/src/packages/serve-packages.ts). Articles link here in
 * a new tab, so the article stays open behind it.
 */
function SimulationLaunch() {
  const { id } = useParams();
  const { t } = useTranslation();
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    getSimulationLaunch(id)
      .then(({ url }) => {
        if (!cancelled) window.location.replace(url);
      })
      .catch((launchError) => {
        if (!cancelled) {
          setError(launchError?.status === 404 ? t('simulation.notFound') : launchError?.message || t('simulation.failed'));
        }
      });

    return () => {
      cancelled = true;
    };
  }, [id, t]);

  return (
    <main className="simulation-launch">
      {error ? (
        <p className="login-message login-message-error" role="alert">
          <i className="fa-solid fa-circle-exclamation" />
          <span>{error}</span>
        </p>
      ) : (
        <p className="page-message">{t('simulation.opening')}</p>
      )}
    </main>
  );
}

export default SimulationLaunch;
